import React from 'react';
import './styles.scss';

const ProgressBar = ({ percentage }: ProgressBarProps) => {
  return (
    <div className="progress-bar">
      <div className="indicator" style={{ width: `${percentage}%` }}></div>
    </div>
  );
};

export default ProgressBar;

interface ProgressBarProps {
  percentage: number;
}
